import { call, put, takeLatest } from "redux-saga/effects";
import axios from "axios";
import {
  FETCH_DASHBOARD_DATA_REQUEST,
  FETCH_DASHBOARD_DATA_SUCCESS,
  FETCH_DASHBOARD_DATA_FAILURE,
  FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
  FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
} from "./DashboardType";
import {
  fetchDashboardDataSuccess,
  fetchDashboardDataFailure,
  fetchVendorDashboardDataSuccess,
  fetchVendorDashboardDataFailure,
  fetchCustomerDashboardDataSuccess,
} from "./DashboardAction";
import axiosInstance from "../instance/AxiosInstance";

const fetchDashboardApi = async () => {
  const response = await axiosInstance.get("/user/userDashBoard");
  return response.data;
};

const fetchVendorDashboardApi = async () => {
  const response = await axiosInstance.get("/user/vendorDashBoard");
  return response.data;
};

const fetchCustomerDashboardApi = async () => {
  const response = await axiosInstance.get("/user/customerdashboard");
  return response.data;
};

function* fetchDashboardDataSaga() {
  try {
    const data = yield call(fetchDashboardApi);
    yield put(fetchDashboardDataSuccess(data));
  } catch (error) {
    yield put(fetchDashboardDataFailure(error.message));
  }
}

function* fetchVendorDashboardDataSaga() {
  try {
    const data = yield call(fetchVendorDashboardApi);
    yield put(fetchVendorDashboardDataSuccess(data));
  } catch (error) {
    yield put(fetchVendorDashboardDataFailure(error.message));
  }
}

function* fetchCustomerDashboardDataSaga() {
  try {
    const data = yield call(fetchCustomerDashboardApi);
    yield put(fetchCustomerDashboardDataSuccess(data));
  } catch (error) {
    yield put(fetchDashboardDataFailure(error.message));
  }
}

export default function* dashboardSaga() {
  yield takeLatest(FETCH_DASHBOARD_DATA_REQUEST, fetchDashboardDataSaga);
  yield takeLatest(
    FETCH_VENDOR_DASHBOARD_DATA_REQUEST,
    fetchVendorDashboardDataSaga
  );
  yield takeLatest(
    FETCH_CUSTOMER_DASHBOARD_DATA_REQUEST,
    fetchCustomerDashboardDataSaga
  );
}
